import axios from 'axios';
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError} from "../../../helpers/ErrorHelper";

function _success(success) {
    return {type: 'GET_GLOBAL_ACTIVITY_LOGS_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_GLOBAL_ACTIVITY_LOGS_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_GLOBAL_ACTIVITY_LOGS_PROCESSING', processing};
}

function getGlobalActivityLogs() {
    return (dispatch,getState) => {
        dispatch(_processing(true));
        dispatch(_error(null));
        let {globalActivityList} = getState();
        let {params} = globalActivityList.data;
        axios({
            url: apiBaseUrl(`admin/activity-logs`),
            method: "get",
            dataType: 'json',
            params,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(`Bearer`)
            }
        }).then(function (res) {
            dispatch(_processing(false));
            dispatch(_success(res));
        }).catch(function (error) {
            handleError(error);
            dispatch(_error(error));
            dispatch(_processing(false));
        });
    }
}

export default getGlobalActivityLogs;
